export const REGISTER = 'REGISTER';
export const REGISTER_CLEAR = 'REGISTER_CLEAR';